import React from "react";

const AppPreloader = props => {
    return (
        <div className="absolute inset-0 bg-white flex items-center justify-center" {...props}>
            <div className="w-32 h-32">
                <svg viewBox="0 0 128 128" className="w-full animate-spin text-indigo-800">
                    <circle cx="64" cy="64" r="48" strokeDasharray="128" strokeWidth="4"
                            strokeLinecap="square"
                            strokeLinejoin="round"
                            stroke="currentColor"
                            fill="none"/>
                </svg>
            </div>
        </div>
    )
}

export default AppPreloader